// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-product-modal',
    // #endregion
    // #region Mixins
    mixins: [host.mixins.modal],
    // #endregion
    // #region Properties
    data: () => ({
        _title: ''
    }),
    props: {
        productNumber: {
            type: String,
            required: false,
            default: ''
        },
        itemNumber: {
            type: String,
            required: false,
            default: ''
        },
        args: {
            type: Object,
            required: false
        },
        mode: {
            type: String,
            required: false,
            default: 'view'
        }
    },
    // #endregion
    // #region Methods
    methods: {
        onProductLoaed(args) {
            this._title = args?.product?.title;
        },
    },
    // #endregion
});
// #endregion
